import React from 'react';
import {Divider, Grid, Hidden, Typography} from '@material-ui/core';
import {Button, UnstyledLink} from '@queensland-running/qr-components';
import {Routes} from '@constants';
import {compose, lifecycle} from 'recompose';
import {Section} from '@components/section/section';
import {FacebookPage} from "@components/social/facebook-page";
import {useTranslation} from "react-i18next";

// const posts = [
//     {
//         title: 'Round 8 & 9 - Cancelled',
//         author: 'Queensland Running',
//         id: '2022-r8-9',
//         date: new Date('2022-05-13'),
//         content:
//             ['As I write this post, it is pouring down!',
//                 'Over the past week South East Queensland has experienced an unseasonal amount of rain, some areas have recorded as much as 200mm.  All season our program has been disrupted by rain, which has caused considerable damage to many of the parks in which we run. This latest downpour has only exacerbated the problems.',
//                 'In addition, Tim and Peter who reside outside of Brisbane are both isolated because of flood waters and cannot get to Brisbane tomorrow.',
//                 'We have reluctantly made the decision to cancel the 7th Brigade Park meet tomorrow, the 14th May.',
//                 'In relation to the meet on the 21st we have also made the difficult decision to cancel that meet. There are several reasons, the main one being the condition of 7th Brigade Park. We know it drains well, but after this incredible amount of rain there will be a lot of standing water. This will make it difficult for Council to have it mown as to have tractors in the Park, the surface will not stand up well. Also it is Election Day and some of our volunteers are working at Polling Booths on that day.',
//                 'Keep checking this page, as with conditions changing, future venues may be altered.'
//             ]
//
//     }
// ]
//   {
//     title: '2020 Calendar',
//     author: 'Queensland Running',
//     id: '2020-calendar',
//     date: new Date('2020-02-01'),
//     content: ['Welcome to the 2020 Queensland Running season. Below is the program.'],
//     tags: ['calendar, 2020'],
//     cta: [
//       {
//         url: '/events/2020',
//         text: 'Calendar',
//       },
//     ],
//   },
// {
//   title: 'Notice of Annual General Meeting 2018',
//   author: 'Queensland Running',
//   id: 'agm-2018',
//   date: new Date('2018-10-16'),
//   content: [
//     'The Annual General Meeting will be held on Monday the 5th of November at 7:30pm at McDonalds Restaurant, Gympie Road, Aspley. Full details are available in documents below;',
//   ],
//   tags: ['agm, meeting, annual, 2018'],
// "cta": [{
//     url: "/assets/pdfs/agm/NOTICE OF ANNUAL GENERAL MEETING 2018.pdf",
//     text: "Notice of AGM"
// }, {
//     url: '/assets/pdfs/agm/AGM MEETING AGENDA 2018.pdf',
//     text: "Meeting Agenda"
// }]
// },
// {
//   title: '25 July 2018 - 7th Brigade Park',
//   author: 'Queensland Running',
//   id: '2018-07-25',
//   date: new Date('2018-07-25'),
//   content: [
//     'The last day of competition includes the 1km, 3km and 4km open championships. These are open championships with categories for masters men and women, the masters age groups are the same as the winter championships. Only open and masters athletes can enter the 1km and 4km championships, however any athlete can enter the 3km championship race as an open runner. Race fees are payable and are the same as listed for the winter championships.',
//   ],
//   tags: ['competition, 2018'],
// },
// {
//   title: 'Upcoming competitions',
//   author: 'Queensland Running',
//   id: '2018-relays',
//   date: new Date('2018-06-06'),
//   content: [
//     'The next competition will be the Rockett Relays will be held at Pine Rivers Park on the 9th of June.',
//     'The Winter Championships will be held at 7th Brigade Park at Geebung on the 23rd of June.',
//   ],
//   tags: ['rockett relays, winter, championships, 2018'],
//   cta: [
//     {
//       url: '/events/rockett-relays',
//       text: 'Rockett Relays',
//     },
//     {
//       url: '/events/winter-championships',
//       text: 'Winter Championships',
//     },
//   ],
// },
// {
//   title: 'QLD All Schools Results',
//   author: 'Queensland Running',
//   id: 'qld-all-schools-2018-results',
//   date: new Date('2018-05-21'),
//   content: [
//     "<p>The results for the 2018 Queensland All Schools Championships are now available. <a href='https://www.webscorer.com/qldrun'>View Results for the All Schools Championships</a></p>",
//   ],
//   tags: ['all schools, results, 2018'],
// },
// {
//   title: 'Running Singlets',
//   author: 'Anne Scott',
//   id: 'running-singlets',
//   date: new Date('2018-05-18'),
//   content: [
//     '<p>There have been request for Queensland Running to look at running singlets or shirts. If you are interested please let us know.</p>',
//   ],
//   tags: ['singlets, 2018'],
// },
// {
//   title: '7th Brigade Park Venue',
//   author: 'Anne Scott',
//   image: '/assets/images/venues/7th Brigade Park.jpg',
//   id: '2018-05-18',
//   date: new Date('2018-05-18'),
//   content: [
//     '<p>Following the positive feedback from runners and parents regarding using the Newman Road end of the park, we have decided to run all of our events there. There is much more parking, the toilets and playground are closer for parents to share their time with little ones and the course was well received. Also the Council has plans to upgrade the roundabout at the Murphy Road/Ellison Road intersection with traffic lights and to increase the number lanes in both Ellison and Murphy Roads, so there with be disruption for some time.</p>',
//   ],
//   tags: ['7th Brigade Park, 2018, venue, venues'],
// },
// {
//   title: '2017 End of Season Wrap-up',
//   author: 'Queensland Running',
//   image: '/assets/images/general/logo_750x300.png',
//   id: '2017-12-06',
//   date: new Date('2017-12-06'),
//   content: [
//     '<p>Another great season, increasing numbers yet again. We would like to extend our sincere appreciation to those volunteers who offered their assistance when we needed additional help on the day – picking up flags, packing up, time keeping and recording, keeping those long queues in order, running the barbeque, helping out at the registration desk, taking photos and looking after road crossings on some courses. And then:</p><p><b>Andrew</b> – we all thank you sincerely for everything you did, every Saturday, throughout the season. That ‘green machine’ knows all the courses and venues so well and is able to work around unexpected obstacles that seem to arise. The kilometres you ride Andrew and then manage to get the occasional run in; supporting the races by acting as the rabbit gives the younger runners that much more confidence. <b>You are a legend!</b></p><p><b>Denise</b> – Fronting the Registration Table, then the Finish Line, clipboard in hand – recording races, your help with the results, Excel and packing up – we are so fortunate to have you every Saturday. <b>Thank you for coming back to us post Jordan!</b></p><p><b>Margaret</b> – out on the course, putting in the flags, then back to man the Registration Desk, off to the finish line and then organising the results and packing up. It is lovely to the strolling figure appear, we miss you when you are away. <b>Our thanks for all you do each week.</b></p><p><b>Steve</b> – a fixture at 7th Brigade Park since we started in 1999, your help with flagging the courses at the various venues (and then always running the 3km!), helping on the start line, organising the finish line and timing, microphone duties when required, collecting the flags (which three hours before you had hammered in!) <b>As a foundation member your contribution is immeasurable.</b></p><p><b>Tim</b> – racing from a cycle race to cross country on Saturday mornings, you organise all our electronic and technical gear, sort out the runners before starting all the races, a man of many talents your dulcet tones are heard throughout the afternoon on the microphone. <b>Good Luck with the Marathon next month! We are pleased that we are part of your busy life.</b></p>',
//   ],
//   tags: ['End of season, 2017, wrap-up'],
// },
// {
//   title: 'Pine Rivers Park - 22 July 2017',
//   subtitle: '1km, 3km & 4km Open and Masters Championships',
//   author: 'Queensland Running',
//   image: '/assets/images/venues/Pine Rivers Park.jpg',
//   id: '2017-07-22',
//   date: new Date('2017-07-22'),
//   content: [
//     '<p>The 1km and 4km open and masters championships were deferred from our winter championship day on 1 July 2017 to reduce the number of races on that day. To be consistent with past years, only open and masters athletes can enter these two championship events.  The 3km event will however be open to all athletes including junior athletes in the open category. To enter the masters categories an athlete needs to be the required age.  The eligibility to enter open race categories will be re-examined for next season.</p><p><b>Program:</b>  The program will be the usual program 1 with the championship events being run with the scheduled events.</p><p><b>Sausage sizzle:</b>  there will be a free sausage sizzle for all competitors to celebrate the last event of the season.</p>',
//   ],
//   tags: ['Pine Rivers Park, Championships, 1km, 3km, 4km, Open, Masters'],
// },
// ];

const enhance = compose(
    lifecycle({
        componentDidMount() {
            // @ts-ignore
            if (window.FB) {
                // @ts-ignore
                window.FB.XFBML.parse();
            }
        },
    }),
);

const HomeView = () => {
    const {t} = useTranslation('common');

    document.title = t('app.title');
    return (
        <>
            <img
                style={{
                    height: '30rem',
                    marginTop: '-1rem',
                    width: '100%',
                    objectFit: 'cover',
                }}
                src="/assets/images/banners/logo_825x465.jpg"
                alt="decorative queensland running banner with logo"
            />
            <br/>
            <br/>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <UnstyledLink to={Routes.calendar}>
                        <Button color="primary"
                                variant="contained"
                                size="large"
                                style={{alignSelf: 'flex-end'}}
                                fullWidth
                                title={t('app.routes.calendar')}
                        />
                    </UnstyledLink>
                    <br/>
                    <br/>
                    <UnstyledLink to={Routes.programs}>
                        <Button color="secondary" variant="contained" size="large" style={{alignSelf: 'flex-end'}}
                                fullWidth
                                title={t('app.routes.programs')}/>
                    </UnstyledLink>
                    <br/>
                    <br/>
                    <UnstyledLink to={Routes.calendar}>
                        <Button color="primary" variant="contained" size="large" style={{alignSelf: 'flex-end'}}
                                fullWidth title={t('app.routes.results')}/>
                    </UnstyledLink>
                    <br/>
                    <br/>
                    <UnstyledLink to={Routes.venues}>
                        <Button color="secondary" variant="contained" size="large" style={{alignSelf: 'flex-end'}}
                                fullWidth
                                title={t('app.routes.venues')}/>
                    </UnstyledLink>
                    <br/>
                    <br/>
                    <UnstyledLink to={Routes.registration}>
                        <Button color="primary" variant="contained" size="large" style={{alignSelf: 'flex-end'}}
                                fullWidth title={t('app.routes.registration')}/>
                    </UnstyledLink>
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<UnstyledLink to={Routes.events}>*/}
                    {/*    <Button color="secondary" variant="contained" size="large" style={{alignSelf: 'flex-end'}}*/}
                    {/*            fullWidth title={t('app.routes.specialEvents')}/>*/}
                    {/*</UnstyledLink>*/}
                    <br/>
                    <br/>
                    <UnstyledLink to={Routes.about}>
                        <Button color="primary" variant="contained" size="large" style={{alignSelf: 'flex-end'}}
                                fullWidth title={t('app.routes.aboutUs')}/>
                    </UnstyledLink>
                    <br/>
                    <br/>
                    <UnstyledLink to={Routes.courseSignage}>
                        <Button color="secondary"
                                variant="contained"
                                size="large"
                                style={{alignSelf: 'flex-end'}}
                                fullWidth
                                title={t('app.routes.courseSignage')}
                        />
                    </UnstyledLink>
                    <br/>
                    <br/>
                    <FacebookPage/>
                </Grid>
                <Grid item xs={12} sm={6} md={9}>
                    {/*<Section verticalSpacing>*/}
                    {/*    <Typography variant="h3" color="primary" gutterBottom>Change of Venue to Huxtable Park - Round 5 (01/04/2023)</Typography>*/}
                    {/*    <Typography>Our booking at 7th Brigade Park, Chermside on Saturday 1 April, is in conflict with*/}
                    {/*        an Easter Festival event also being held in the park. After much discussion, we have decided*/}
                    {/*        in the interests of safety for all our runners to move our event to Huxtable Park at*/}
                    {/*        Chermside West. As vehicles will be permitted to enter and park in the area where we run and*/}
                    {/*        we thought especially with so many younger runners Huxtable Park would be a safer option for*/}
                    {/*        all concerned.*/}
                    {/*        We do apologise for the change at this stage, but were only made aware of the issue*/}
                    {/*        yesterday.</Typography>*/}

                    {/*</Section>*/}
                    {/*<Section verticalSpacing>*/}
                    {/*    <Typography variant="h3" color="primary" gutterBottom>Notice of Annual General Meeting*/}
                    {/*        2023</Typography>*/}
                    {/*    <Typography>The Annual General Meeting will be held on Monday the 27th of February at 7:30pm.*/}
                    {/*        Location and full details are available in documents below;</Typography>*/}
                    {/*    <UnstyledA href={'/assets/pdfs/agm/NOTICE OF ANNUAL GENERAL MEETING 2023.pdf'} target="_blank"*/}
                    {/*               rel="noopener noreferrer">*/}
                    {/*        <Button color={'primary'} variant={'contained'} title="Notice of AGM"/>*/}
                    {/*    </UnstyledA>*/}
                    {/*    <br/>*/}
                    {/*    <br/>*/}
                    {/*    <UnstyledA href="/assets/pdfs/agm/AGM MEETING AGENDA 2023.pdf">*/}
                    {/*        <Button color="primary" variant='contained' title="Meeting Agenda"/>*/}
                    {/*    </UnstyledA>*/}
                    {/*</Section>*/}
                    <Section>
                        <Typography variant="h3" color="primary" gutterBottom>
                            Volunteering
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="body1">
                                    With the ever increasing number of runners attending our weekly events, we require
                                    volunteers to assist with
                                    the following tasks each week, otherwise our events cannot continue:
                                </Typography>
                                <ul>
                                    <li>course marking</li>
                                    <li>assisting runners with the nomination process</li>
                                    <li>receiving weekly nominations, including weekly fees</li>
                                    <li>recording race finishes</li>
                                    <li>course marshalls out on the course</li>
                                </ul>
                                <Typography variant="body1" gutterBottom>
                                    Volunteers can assist for as little as half an hour.
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    Please consider acting as a volunteer official at our weekly events during the
                                    season.
                                </Typography>
                                <br/>
                                <UnstyledLink to={Routes.volunteer}>
                                    <Button color="secondary" variant="contained" style={{alignSelf: 'flex-end'}}
                                            title={t('app.routes.volunteer')}/>
                                </UnstyledLink>
                            </Grid>
                            <Hidden smDown>
                                <Grid item md={6}>
                                    <img width="100%" src="/assets/images/general/volunteer.jpg"
                                         alt="young girl helping by collecting flags"/>
                                </Grid>
                            </Hidden>
                        </Grid>
                        <br/>
                        The Queensland Government provided $2,500 to Queensland Running to assist volunteers to enable Queenslanders to participate in sport and recreation activities.

                    </Section>
                </Grid>
                <Divider/>
                <br/>
            </Grid>
        </>
    );
};

export const Home = enhance(HomeView);
